const css = `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
/*React-headroom*/
.headroom-wrapper {
  max-height: 100px;
}

/* header */
.dark-menu {
  background-color: #171c28 !important;
  color: #ffffff;
}

.dark-menu li a {
  color: #ffffff !important;
}

.dark-menu li a:hover {
  background-color: #55198b !important;
}

.header {
  background-color: #fff;
  max-width: 100%;
  padding: 15px 20px;
  margin: 0px auto;
}

.header ul {
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: hidden;
}

.grey-color {
  color: #868e96;
}

.header li a {
  display: block;
  padding: 15px 20px;
  color: #000000;
  text-decoration: none;
}

.header li a:hover,
.header .menu-btn:hover {
  background-color: #f4f4f4;
}

.header .logo {
  display: block;
  flex: none;
  float: left;
  font-size: 1.5em;
  word-spacing: 10px;
  text-decoration: none;
  margin-top: 10px;
  line-height: normal;
}

.header .logo-name {
  font-family: "Agustina Regular";
  font-weight: bold;
  font-variant-ligatures: no-common-ligatures;
  -webkit-font-variant-ligatures: no-common-ligatures;
  padding: 0 10px;
}

/* menu */
.header .menu {
  clear: both;
  max-height: 0;
  transition: max-height 0.2s ease-out;
}

/* menu icon */
.header .menu-icon {
  cursor: pointer;
  display: inline-block;
  float: right;
  padding: 28px 20px;
  position: relative;
  user-select: none;
}

.header .menu-icon .navicon {
  background: #333;
  display: block;
  height: 2px;
  position: relative;
  transition: background 0.2s ease-out;
  width: 18px;
}

.header .menu-icon .navicon-dark {
  background: #ffffff;
}

.header .menu-icon .navicon:before,
.header .menu-icon .navicon:after {
  background: #333;
  content: "";
  display: block;
  height: 100%;
  position: absolute;
  transition: all 0.2s ease-out;
  width: 100%;
}

.header .menu-icon .navicon-dark:before,
.header .menu-icon .navicon-dark:after {
  background: #ffffff !important;
  content: "";
  display: block;
  height: 100%;
  position: absolute;
  transition: all 0.2s ease-out;
  width: 100%;
}

.header .menu-icon .navicon:before {
  top: 5px;
}

.header .menu-icon .navicon:after {
  top: -5px;
}

/* menu btn */
.header .menu-btn {
  display: none;
}

.header .menu-btn:checked ~ .menu {
  max-height: 486px;
}

.header .menu-btn:checked ~ .menu-icon .navicon {
  background: transparent !important;
}

.header .menu-btn:checked ~ .menu-icon .navicon:before {
  transform: rotate(-45deg);
}

.header .menu-btn:checked ~ .menu-icon .navicon:after {
  transform: rotate(45deg);
}

.header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:before,
.header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:after {
  top: 0;
}

/* 48em = 768px */
@media (min-width: 48em) {
  .header li {
    float: left;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .header .menu {
    max-height: none;
  }
  .header .menu-icon {
    display: none;
  }
}
@media (max-width: 960px) and (min-width: 768px) {
  .header {
    font-size: 12px;
  }
  .header .logo {
    font-size: 1.2em;
  }
}
@media (max-width: 768px) {
  .header .logo {
    font-size: 1.2em;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
